import { Outlet } from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';
import WhatsAppFloat from '../common/WhatsAppFloat/WhatsAppFloat';

export default function MainLayout() {
  return (
    <>
      <Navbar />
      <main className="main-content">
        <Outlet />
      </main>
      <WhatsAppFloat />
      <Footer />
    </>
  );
}
